import { render, staticRenderFns } from "./BrandMark.vue?vue&type=template&id=c1168ad0&scoped=true"
import script from "./BrandMark.vue?vue&type=script&lang=js"
export * from "./BrandMark.vue?vue&type=script&lang=js"
import style0 from "./BrandMark.vue?vue&type=style&index=0&id=c1168ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1168ad0",
  null
  
)

export default component.exports